export default __webpack_public_path__ + "static/media/crypto.8337d57d.png";